import {
    REQUIRED_EMAIL_VERIFICATION,
    REQUIRED_PHONE_VERIFICATION,
    REQUIRED_PASSWORD_VERIFICATION,
} from '@/consts';
import { LinkAuthFlow, PolicySetting } from '../../types/types';
import { PolicyAggregate } from './getPolicyAggregate';

const makeRequirement = (id: string): PolicySetting => ({
    id,
    type: 'switch',
    value: true,
    description: id,
    public: true,
});

/**
 * Maps the PII-free `GET /links/{linkId}/auth-flow` response into the same
 * `PolicyAggregate` shape the recipient UI historically derived from file
 * policies, so OTP gating can be driven pre-auth without fetching file
 * metadata. When the backend reports no verification requirement we keep the
 * long-standing fallback of gating with email verification so a link is never
 * left without an authentication gate.
 */
const authFlowToRequirements = (authFlow: LinkAuthFlow | null): PolicyAggregate => {
    const aggregate: PolicyAggregate = {};
    if (authFlow?.requireEmailVerification) {
        aggregate[REQUIRED_EMAIL_VERIFICATION] = makeRequirement(REQUIRED_EMAIL_VERIFICATION);
    }
    if (authFlow?.requirePhoneVerification) {
        aggregate[REQUIRED_PHONE_VERIFICATION] = makeRequirement(REQUIRED_PHONE_VERIFICATION);
    }
    if (authFlow?.requirePasswordVerification) {
        aggregate[REQUIRED_PASSWORD_VERIFICATION] = makeRequirement(REQUIRED_PASSWORD_VERIFICATION);
    }

    // Fail closed: when the auth-flow is absent (null) or reports no requirement,
    // still gate with email verification so a link is never left without an
    // authentication gate.
    if (!Object.keys(aggregate).length) {
        aggregate[REQUIRED_EMAIL_VERIFICATION] = makeRequirement(REQUIRED_EMAIL_VERIFICATION);
    }

    return aggregate;
};

export default authFlowToRequirements;
